import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import styles from './styles.module.scss';

import { ReactComponent as ArrowUp } from '../../../assets/icons/icon-arrow-up.svg';
import { ReactComponent as ArrowDown } from '../../../assets/icons/icon-arrow-down.svg';

import { spanish } from '../../../config/config';

const Item = ({ item }) => {
  const [active, setActive] = useState(false);
  return (
    <div className={styles.item}>
      <button
        type="button"
        className={styles.button}
        onClick={() => setActive(!active)}
      >
        <div className={styles.question}>
          {spanish ? item?.QuestionSpanish : item?.QuestionEnglish}
        </div>
        <div className={styles.arrow}>
          {active ? <ArrowUp /> : <ArrowDown />}
        </div>
      </button>
      {active && (
        <div className={styles.answer}>
          <ReactMarkdown
            children={spanish ? item?.AnswerSpanish : item?.AnswerEnglish}
          />
        </div>
      )}
    </div>
  );
};

const FAQcontent = ({ data }) => (
  <div className={styles.container}>
    {data?.map((item, key) => (
      <Item item={item} key={key} />
    ))}
  </div>
);

export default FAQcontent;
